/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Common
 */

/**
 * Enumeration for horizontal alignment.
 * @public
 * @deprecated in 4.15.0. Used internally.
 */
export enum HorizontalAlignment {
  Left = "left",
  Center = "center",
  Right = "right",
  Justify = "justify",
}

/**
 * Enumeration for vertical alignment.
 * @public
 * @deprecated in 4.15.0. Not used by AppUI.
 */
export enum VerticalAlignment {
  Top = 1,
  Middle = 2,
  Bottom = 3,
}
